module.exports = __webpack_public_path__ + "static/img/teamHonorBg6.ece85f3b.png";